import { RouteObject } from "react-router";

import { authCallbackRoute } from "@punto/frontend-shared/providers/auth-callback-route";

import { routePaths } from "@/router/route-paths";

import { lazyRoute } from "./lazy-route";

const Screens = {
  Login: () => import("@/modules/auth/screens/login-screen"),
  Logout: () => import("@/modules/auth/screens/logout-screen"),
};

export const publicRoutes: RouteObject[] = [
  authCallbackRoute,
  {
    path: routePaths.login,
    lazy: lazyRoute(Screens.Login),
  },
  {
    path: routePaths.logout,
    lazy: lazyRoute(Screens.Logout),
  },
];
